// Импортируем наше фоновое изображение. 
// Сборщик обработает его и вернет нам финальный путь в переменную heroBg.
import heroBg from '../../assets/images/hero-background.jpg';

// Импортируем библиотеку React, чтобы иметь возможность использовать JSX-синтаксис (похожий на HTML).
import React from 'react';

// Импортируем наши стили как CSS-модуль. Это позволяет создавать классы,
// уникальные только для этого компонента (например, styles.title),
// что предотвращает конфликты стилей с другими компонентами.
import styles from './HeroSection.module.css';

// Определяем наш компонент HeroSection как функциональный компонент.
const HeroSection = () => {
  // Компонент должен вернуть один корневой элемент с разметкой.
  return (
    // Используем семантический тег <section> для блока контента.
    // Атрибут id="home" нужен, чтобы на этот блок могли ссылаться якорные ссылки (например, из шапки).
    // className={styles.heroSection} применяет основные стили для секции из нашего CSS-модуля.
    // Мы добавляем инлайн-стиль, чтобы установить фон.
	// Обратите внимание на двойные фигурные скобки {{...}}.
	// Внутри `` (обратных кавычек) мы создаем строку и вставляем в нее путь из переменной heroBg.
	<section 
		id="home" 
		className={styles.heroSection} 
		style={{ backgroundImage: `url(${heroBg})` }}
	>
      {/* 
        Используем глобальный класс "container" для центрирования контента 
        и ограничения его по ширине на больших экранах.
      */}
      <div className="container">
        {/* Этот div является оберткой для нашего текстового контента, чтобы его можно было легко стилизовать. */}
        <div className={styles.heroContent}>
          {/* 
            Главный заголовок страницы <h1>. Это самый важный элемент для SEO.
            Он должен быть только один на всей странице и содержать ключевые слова.
          */}
          <h1 className={styles.title}>
            Современные бетонные заводы (БРУ) в Казахстане
          </h1>

          {/* 
            Подзаголовок <p>, который более подробно раскрывает суть 
            уникального торгового предложения (УТП).
          */}
          <p className={styles.subtitle}>
            Готовые решения для вашего строительного бизнеса: от мобильных установок 
            до стационарных комплексов. Прямые поставки и сервисное обслуживание.
          </p>

          {/* 
            Группа с кнопками призыва к действию (Call-to-Action).
            Предоставляем пользователю основной и второстепенный варианты действий.
          */}
          <div className={styles.buttonGroup}>
            {/* Основная кнопка, ведущая на форму контактов */}
            <a href="#contact" className={`${styles.button} ${styles.primaryButton}`}>
              Получить каталог с ценами
            </a>
            
            {/* Второстепенная кнопка, ведущая на секцию с каталогом товаров */}
            <a href="#catalog" className={`${styles.button} ${styles.secondaryButton}`}>
              Смотреть модели
            </a>
          </div>
        </div>
      </div>

      {/* 
        Этот div-элемент используется для создания полупрозрачного затемняющего слоя (оверлея)
        поверх фонового изображения. Это критически важно для того, чтобы белый текст 
        хорошо читался на любом, даже очень светлом или пестром, фоне.
      */}
      <div className={styles.overlay}></div>
    </section>
  );
};

// Экспортируем наш компонент, чтобы его можно было импортировать и использовать в других файлах (например, в App.jsx).
export default HeroSection;